import { make } from 'vuex-pathify'

const state = {
  ready: false,
  showErrorModal: false,
  showNotAuthorizedModal: false,
  errors: [],
  selectedDistrictId: 17
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations
}
